import { useMemo } from "react";
import { BRAND, brandMarkDataUri } from "@jange/shared";

/**
 * Logo Jang-e (touche « e » coiffée du chapeau d'élève), depuis la source unique du dépôt.
 * Par défaut il suit le thème (encre en clair, blanc en sombre) ; `onDark` force la version claire.
 */
export function BrandMark({ size = 24, onDark = false }: { size?: number; onDark?: boolean }) {
  const ink = useMemo(() => brandMarkDataUri({ key: BRAND.ink, hat: BRAND.amber }), []);
  const white = useMemo(() => brandMarkDataUri({ key: BRAND.white, hat: BRAND.amber }), []);
  const img = (src: string, cls?: string) => <img src={src} width={size} height={size} alt="" aria-hidden className={cls} style={cls ? { flexShrink: 0 } : { display: "block", flexShrink: 0 }} />;
  if (onDark) return img(white);
  return <>{img(ink, "theme-light-only")}{img(white, "theme-dark-only")}</>;
}
